<div [attr.uialert]="type()">
  <icon uialerticon [iconDefinition]="icon"></icon>
  <span uialerttitle>{{ title() }}</span>
  <div uialertcontent>
    {{ message() }}
    <ng-content select="[uialertcontent]"></ng-content>
  </div>
  <div uialertactions>
    <ng-content select="[uialertactions]"></ng-content>
  </div>
</div>
